import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App-Footer-Links" }
const _hoisted_2 = { class: "App-Footer-Info" }
const _hoisted_3 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["App-Footer", `App-Footer-${_ctx.size}`])
  }, [
    _createVNode(_component_el_space, {
      direction: "vertical",
      "w-100": "",
      fill: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_space, {
            alignment: "center",
            style: {"justify-content":"center"},
            wrap: "",
            size: 10,
            "txt-center": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_link, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openLink('terms-of-service'))),
                "txt-center": ""
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode(" Terms of Service ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_link, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openLink('terms-of-use'))),
                "txt-center": ""
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode(" Terms of Use ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_link, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openLink('privacy-policy'))),
                "txt-center": ""
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode(" Privacy Policy ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_link, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openLink('cookie-policy'))),
                "txt-center": ""
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode(" Cookie Policy ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_link, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openLink('glossary'))),
                "txt-center": ""
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode("Glossary", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, " Copyright © 2021 - " + _toDisplayString(_ctx.currentYear) + " Equity4Talent Limited. All rights reserved. ", 1),
          _cache[10] || (_cache[10] = _createElementVNode("div", { "txt-center": "" }, "VAT Reg Number 397 0593 54", -1)),
          _cache[11] || (_cache[11] = _createElementVNode("div", { "txt-center": "" }, " Level 39, One Canada Square, Canary Wharf, London E14 5AB, UK ", -1))
        ])
      ]),
      _: 1
    })
  ], 2))
}